import { useRef } from 'react';
import { Icon } from '../../UI';

const ScrollArrows = ({ children, className = '' }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  function handleScroll(direction: 'left' | 'right') {
    if (ref.current === null) return;
    direction === 'left'
      ? (ref.current.scrollLeft -= 100)
      : (ref.current.scrollLeft += 100);
  }

  return (
    <div className={`${className} flex justify-between items-center`}>
      <div
        className="h-full flex items-center px-2 cursor-pointer select-none"
        onClick={() => handleScroll('left')}
      >
        <Icon svgName="arrowLeftScroll" className="w-3 h-3" />
      </div>
      <div
        ref={ref}
        style={{ scrollBehavior: 'smooth' }}
        className="flex items-center overflow-x-auto scrollbar-hide flex-1 w-1 gap-4"
      >
        {children}
      </div>
      <div
        className="h-full flex items-center px-2 cursor-pointer select-none"
        onClick={() => handleScroll('right')}
      >
        <Icon svgName="arrowRightScroll" className="w-3 h-3" />
      </div>
    </div>
  );
};

export default ScrollArrows;
